import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FAreaResponseModule } from "@farris/ui-area-response";
import { ComboListModule } from "@farris/ui-combo-list";
import { FarrisCommonModule } from "@farris/ui-common";
import { DataColumnModule } from "@farris/ui-common/column";
import { DateHelperModule } from "@farris/ui-common/date";
import { LocaleModule } from "@farris/ui-locale";
import { MessagerModule } from "@farris/ui-messager";
import { ModalModule } from "@farris/ui-modal";
import { NotifyModule } from "@farris/ui-notify";
import { PaginationModule } from '@farris/ui-pagination';
import {
  FFilePreviewComponent,
  FFileUploadComponent,
  FFileViewImageComponent,
  PreviewBaseEditorDirective,
  PreviewCheckboxComponent,
  PreviewComboListComponent,
  PreviewTextboxComponent,
} from "./components/index";
import { MultiDownloadInfoComponent } from "./components/multi-download-info/multi-download-info.component";
import { PreviewCellComponent } from "./components/preview-cell/preview-cell.component";
import { ColumnResizerDirective } from "./components/upload-and-preview/column-resizer.directive";
import { UploadFileOrderDragDirective } from "./components/upload-and-preview/file-order-drag.directive";
import { UploadAndPreviewComponent } from "./components/upload-and-preview/upload-and-preview.component";
import { UploadProgressComponent } from "./components/upload-progress/upload-progress.component";
import {
  FFileDropDirective,
  FFilePreviewListTypeTemplateDirective,
  FFilePreviewToolbarTemplateDirective,
  FFileSelectDirective,
  FFileUploadDirective,
  PreviewCellEditorDirective,
} from "./directive/index";
import { UploadServerService } from "./model/index";
import {
  FFileDatePipe,
  FFileSizePipe,
  FormatCellDataPipe,
  UPLocaleDefaultPipe,
  UPLocalePipe,
  UPShowRequiredStarPipe,
} from "./pipe/index";
import {
  FFileUploadAPIServiceToken,
  FFileUploadDefaultService,
  FFileUploaderService,
  FFileUploadServerConfig,
} from "./service/index";
import {AngularDraggableModule} from "@farris/ui-draggable"
@NgModule({
  declarations: [
    FFileDropDirective,
    FFileSelectDirective,
    FFileUploadComponent,
    FFileViewImageComponent,
    FFilePreviewComponent,
    FFilePreviewListTypeTemplateDirective,
    FFileUploadDirective,
    PreviewCheckboxComponent,
    FFilePreviewToolbarTemplateDirective,
    FFileSizePipe,
    ColumnResizerDirective,
    UploadAndPreviewComponent,
    UploadProgressComponent,
    FFileDatePipe,
    MultiDownloadInfoComponent,
    UploadFileOrderDragDirective,
    FormatCellDataPipe,
    UPLocalePipe,
    UPLocaleDefaultPipe,
    PreviewCellComponent,
    PreviewCellEditorDirective,
    UPShowRequiredStarPipe,
    PreviewBaseEditorDirective,
    PreviewTextboxComponent,
    PreviewComboListComponent,
  ],
  exports: [
    FFileDropDirective,
    FFileSelectDirective,
    FFileUploadComponent,
    FFileViewImageComponent,
    FFilePreviewComponent,
    FFilePreviewListTypeTemplateDirective,
    FFileUploadDirective,
    FFilePreviewToolbarTemplateDirective,
    FFileSizePipe,
    ColumnResizerDirective,
    UploadAndPreviewComponent,
    UploadProgressComponent,
    FFileDatePipe,
    UploadFileOrderDragDirective,
    PreviewCellEditorDirective,
    PreviewCellComponent,
    PreviewTextboxComponent,
    PreviewComboListComponent,
  ],
  imports: [
    CommonModule,
    NotifyModule,
    MessagerModule,
    FAreaResponseModule,
    FarrisCommonModule,
    DateHelperModule.forRoot(),
    ModalModule.forRoot(),
    LocaleModule.forRoot(),
    DataColumnModule.forRoot(),
    ComboListModule,
    FormsModule,
    ReactiveFormsModule,
    AngularDraggableModule,
    PaginationModule
  ],
  providers: [
    FFileUploaderService,
    {
      provide: UploadServerService,
      useClass: FFileUploadDefaultService,
    },
  ],
  entryComponents: [
    MultiDownloadInfoComponent,
    PreviewTextboxComponent,
    PreviewComboListComponent,
  ],
})
export class FFileUploadModule {
  static forRoot(
    config?: FFileUploadServerConfig,
    uploadSer?: any
  ): ModuleWithProviders {
    return {
      ngModule: FFileUploadModule,
      providers: [
        { provide: FFileUploadAPIServiceToken, useValue: config },
        FFileUploaderService,
        {
          provide: UploadServerService,
          useClass: uploadSer || FFileUploadDefaultService,
        },
      ],
    };
  }
}
